<div class="wrapper" role="none" aria-hidden="true">
  <div class="item">
    <span aria-hidden="true">Powered by </span>
    <a href="https://positivecinema.com/" target="_blank" aria-labelledby="contributor" tabindex="-1">Positive Cinema</a>
  </div>
  <p id="contributor" class="sr-only">{{ 'wcag.footer.contributor' | translate }}</p>
</div>
